import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingBag, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const linkClass = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 text-sm rounded-lg transition-colors ${
    isActive ? "bg-[#111111] text-white" : "text-[#5C5C5C] hover:bg-[#EBE8E3]"
  }`;

const AdminLayout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen flex bg-[#F9F8F6] text-[#111111]">
      <aside className="w-64 border-r border-[#EBE8E3] p-6 flex flex-col">
        <p className="font-serif-lux text-2xl font-semibold mb-1">DNA Admin</p>
        <p className="text-xs text-[#5C5C5C] mb-8">{user?.name}</p>

        <nav className="flex flex-col gap-1">
          <NavLink to="/admin" end className={linkClass}>
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink to="/admin/products" className={linkClass}>
            <Package size={16} /> Products
          </NavLink>
          <NavLink to="/admin/orders" className={linkClass}>
            <ShoppingBag size={16} /> Orders
          </NavLink>
        </nav>

        <div className="mt-auto flex flex-col gap-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-[#5C5C5C] hover:text-[#111111] transition-colors">
            <ExternalLink size={14} /> View Store
          </Link>
          <button onClick={logout} className="text-left text-xs text-[#5C5C5C] hover:text-[#111111] transition-colors">
            Log Out
          </button>
        </div>
      </aside>

      <main className="flex-1 p-10 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
